export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7040.650b093e.jpg";